import configDataFn from '@/baseData/accident/manageList'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const jumpDetail = (query) => {
    this.$router.push({
      path: '/driver/customerManage/detail',
      query,
    })
  }
  const operate = {
    name: 'operate',
    columnProps: {
      label: '操作',
      width: 240,
      fixed: 'right',
    },
    type: 'operate',
    maxShowLength: operateMaxShowLength,
    getOperateList: ({ row }) => {
      const arr = [
        { name: 'detail', label: '详情', action: () => jumpDetail({ id: row.id, tabType: 'accident' }) },
      ]
      return arr
    },
  }
  const { configData } = configDataFn.call(this, { dealWithData: this.dealWithData })
  configData.tableData.columns.push(operate)
  configData.formData.exportData = {
    exportTemplate: 'Accident',
    filename: '事故管理列表.xlsx',
    permissionName: 'driver_customer_list_detail',
  }
  return { configData }
}
